import { render, staticRenderFns } from "./import-changes.vue?vue&type=template&id=c779412c&scoped=true"
import script from "./import-changes.vue?vue&type=script&lang=ts"
export * from "./import-changes.vue?vue&type=script&lang=ts"
import style0 from "./import-changes.vue?vue&type=style&index=0&id=c779412c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c779412c",
  null
  
)

export default component.exports